import React, {useContext, useEffect, useState} from "react";
import {Button, Col, Divider, Form, Input, message, Popconfirm, Row, Space} from 'antd';
import {AppController} from "../App";
import {startCase, pick} from "lodash";
import AodSelector from "../AodUi/AodSelector";
import ModalForm from "../uiUtils/ModalForm";
import {ArrowRightOutlined, DeleteOutlined, FormOutlined, PlusOutlined} from "@ant-design/icons";
import LogoManager from "./LogoManager";


export default function ChooseAdvertiser(
    {
        advertiser, onSelect,
        logo, setLogo,  //todo ? just adding logo should be enough
        next,
        advSsTotal,
        ...props
    })
{
    const [createCompanyVisible, setCreateCompanyVisible] = useState(false);
    const [updateCompanyVisible, setUpdateCompanyVisible] = useState(false);
    const controller = useContext(AppController);

    //todo this is a bit clarty -? create new company in AdvertiserChooser
    function onSelectAdvertiser(advertiser) {
        if (advertiser.id) {
            onSelect(advertiser);
        }
    }

    async function createAdvertiser(company){
        try {
            const advertiserInfo = {
                name: company.name,
                company
            };
            const newAdvertiser = await controller.createAdvertiser(advertiserInfo);
            onSelect(newAdvertiser);
        } catch (e) {
            message.error(`Error creating advertiser ${company.name}  ` +
                (e.message && e.message) );
            // todo trap duplicate name
        }
    }

    async function updateAdvertiser(company){
        try {
            const advertiserInfo = {
                ...pick(advertiser, 'id', 'recordVersion', 'accountId'),
                name: company.name,
                company: {
                    ...company,
                    ... pick(advertiser.company, 'id', 'recordVersion')
                }
            };
            const newAdvertiser = await controller.updateAdvertiser(advertiserInfo);
            onSelect(newAdvertiser);
        } catch (e) {
            message.error(`Error updating advertiser ${company.name}  ` +
                (e.message && e.message) );
            // todo trap duplicate name
        }
    }

    async function deleteAdvertiser(company){
        try {
            company.id = advertiser.company.id;
            const advertiserInfo = {
                id: advertiser.id,
                name: company.name,
                company
            };
            await controller.deleteAdvertiser(advertiserInfo);
            onSelect();
        } catch (e) {
            message.error(`Error deleting advertiser ${company.name}  ` +
                (e.message && e.message) );
        }
    }

    //todo pass down current advertiser state
    //todo company form can get in funky state if setting adv when there are errors
    return (
        <div {...props}>
            <Row>
                <Col span={5} offset={1} style={{
                    textAlign:'right',
                    color: 'rgba(0,0,0,0.85)',
                    lineHeight: '40px',
                    whiteSpace: 'nowrap',
                    verticalAlign: 'middle',
                    paddingRight: 8,
                    fontWeight: 600
                }}>
                    Find Advertiser:
                </Col>
                <Col span={17}>
                    <AodSelector itemType={'advertiser'} setName={'selected_account'}
                                 label={'name'}
                                 width={400}
                                 onSelect={onSelectAdvertiser}
                                 placeholder={'select an existing advertiser'}
                                 value={advertiser}
                    />
                </Col>
            </Row>
            <Row style={{height:10}}/>
            <Row>
                <Col span={22} offset={1}>
                    <Space>
                        <Button icon={<PlusOutlined />} type={'primary'}
                                onClick={()=>setCreateCompanyVisible(true)}
                        >Create new advertiser</Button>
                        <Button icon={<FormOutlined />}
                                onClick={()=>setUpdateCompanyVisible(true)}
                                disabled={!advertiser}
                        >Update advertiser</Button>
                        <Popconfirm title={'Comfirm delete'}
                                        okText={'Delete'}
                                        onConfirm={deleteAdvertiser}
                                        disabled={!advertiser || advSsTotal !== 0}
                            >
                            <Button icon={<DeleteOutlined />}
                                    disabled={!advertiser || advSsTotal !== 0}
                              >Delete advertiser</Button>
                        </Popconfirm>
                    </Space>
                </Col>
            </Row>
            <Divider/>
            <Row style={{height:180}}>
                <Col span={22} offset={1}>
                    <LogoManager {...{logo, setLogo, advertiser}}/>
                </Col>
            </Row>
            <Divider/>
            <Row>
                <Col span={22} offset={1}>
                    <Space>
                        <Button icon={<ArrowRightOutlined />} type={'primary'}
                                disabled={!advertiser} onClick={()=>next()}
                        >Next</Button>
                    </Space>
                </Col>
            </Row>

            <CompanyModal
                visible={createCompanyVisible}
                title="Create new advertiser"
                onSubmit={createAdvertiser}
                onCancel={()=>setCreateCompanyVisible(false)}
                onFailed={err => message.error(err.message)}
            />

            <CompanyUpdateModal
                visible={updateCompanyVisible}
                title="Update advertiser"
                onSubmit={updateAdvertiser}
                onCancel={()=>setUpdateCompanyVisible(false)}
                onFailed={err => message.error(err.message)}
                company={advertiser && advertiser.company}
            />
        </div>
    );
}

// todo singleCompany Modal - support hidden id to indicate update
function CompanyModal({onSubmit, onFailed, visible, ...props}){
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields()
        }
    }, [visible]);

    return <ModalForm
        okText={'Create'}
        form={form}
        formProps={{onFinish:onSubmit, onFinishFailed:onFailed}}
        visible={visible}
        {...props}
    >
        <CompanyFormItems />
    </ModalForm>
}

function CompanyUpdateModal({onSubmit, onFailed, visible, company, ...props}){
    const [form] = Form.useForm();

    useEffect(() => {
        if (visible) {
            form.resetFields()
        }
    }, [visible]);

    return <ModalForm
        okText={'Update'}
        form={form}
        formProps={{
            onFinish:onSubmit,
            onFinishFailed:onFailed,
            initialValues: company
        }}
        visible={visible}
        {...props}
    >
        <CompanyFormItems />
    </ModalForm>
}

function CompanyFormItems({...props}){

    const order = ['address1', 'city', 'state', 'zip', 'web', 'phone'];
    const getLabel = field => startCase(field.replace(/\d*$/,''));

    return <>
        <Form.Item name={'name'} label={'Name'} rules={[{required:true }]} key={'name'}>
            <Input placeholder={'company name'}/>
        </Form.Item>
        { order.map(f=><Form.Item name={f} label={getLabel(f)} key={f}>
                <Input />
            </Form.Item>)
        }
    </>
}


